// extracted by css-extract-rspack-plugin
export default {"rows":"a8ugW_WgSRoGPom6","row":"zlg1CB0mNkU5XynR","rowTitle":"QTJEbI5DLi0sPUVd","valueCell":"QlztWN7ENjINkhq_"};